import type { HtmlAttributes } from '@studio/design-system/props';
import type { T_Nullable } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useProducer, useStore } from '../store/hooks.js';
import { Content } from './content.jsx';
import { Footer } from './footer.jsx';
import { Panel as _Panel } from '#~/common/editor/index.js';

/** Manufacturer `<Panel>` component. */
export const Panel = (props: HtmlAttributes): T_Nullable<ReactElement> => {
  const producer = useProducer();
  const isReady = useStore(({ manufacturer }) => !!manufacturer.config);

  // Can we continue to the next step in the workflow?
  useEffect(() => {
    producer(({ manufacturer }) => {
      manufacturer.isReady = isReady;
    });
  }, [isReady]);

  return (
    <_Panel {...props}>
      <Content />
      <Footer />
    </_Panel>
  );
};
